import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Mask } from 'src/app/utils/masks';
import { onChangeDate, openCalendarDatepicker } from 'src/app/utils/moment-config-datepicker';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { getIiconeSeguradora } from 'src/app/utils/FormatterSeguradoras';
import { UtilsService } from 'src/app/services/utils.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { PageModules } from 'src/app/utils/pageModules';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';

@Component({
    selector: 'filtro-parcelas',
    templateUrl: './parcelas.component.html',
    styleUrls: ['./parcelas.component.scss'],
    imports: [
      CommonModule,
      PageModules,
      ModulosDeFormulario,
      MatFormFieldModule
    ],
})
export class FiltroParcelasComponent implements OnInit {

  masks = Mask;

  seguradora:any = this.filtroController.filtroParcelas?.seguradora ? this.filtroController.filtroParcelas?.seguradora :  0;

  seguradoras:any = [
    {
      nome: 'Todas',
      value: 0,
      id: ''
    },
    {
      nome: 'Aliro',
      value: 22,
      id: ''
    },
    {
      nome: 'Allianz',
      value: 5,
      id: ''
    },
    {
      nome: 'Azul',
      value: 10,
      id: ''
    },
    {
      nome: 'Bradesco',
      value: 1,
      id: ''
    },
    {
      nome: 'HDI',
      value: 4,
      id: ''
    },
    {
      nome: 'Yelum',
      value: 12,
      id: ''
    },
    {
      nome: 'Mapfre',
      value: 3,
      id: ''
    },
    {
      nome: 'Mitsui',
      value: 13,
      id: ''
    },
    {
      nome: 'Porto',
      value: 8,
      id: ''
    },
    {
      nome: 'Sompo',
      value: 6,
      id: ''
    },
    {
      nome: 'Sul América',
      value: 17,
      id: ''
    },
    {
      nome: 'Tokio',
      value: 11,
      id: ''
    },
    {
      nome: 'Zurich',
      value: 7,
      id: ''
    }
  ]

  openCalendar = openCalendarDatepicker;
  onChange = onChangeDate;


  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();

  constructor(
    public filtroController: FiltroControllerService,
    public utilsService: UtilsService,
    private icons: RegisterIconsService,
  ) {
    icons.registerIcons(['calendar']);
  }

  ngOnInit(): void {
    this.getImagesSeguradoras();
  }

  getImagesSeguradoras() {
    this.seguradoras.forEach(e => {
      e.img = getIiconeSeguradora(e.value);
    });
  }


  clearFilter() {
    this.seguradora = 0;
    this.filtroController.limparFiltro('parcelas');
    this.limpaFiltro.emit();
    this.filtroController.verificaFiltro();
    this.buildString();
  }

  getSeguradora(e) {
    this.seguradora = e.value;
  }

  buildString(oculto?:boolean) {
    let jsonEnvio = {
      seguradora: this.seguradora ? this.seguradora : ''
    }
    if(oculto){
      jsonEnvio['oculto'] = true;
    }

    let filtros = { values: jsonEnvio }
    this.filtroController.addFiltrosExtras('parcelas', filtros);
    this.eventFilter.emit(filtros)

  }

}
